import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class Actives extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activesList: [],
        };
    }

    componentDidMount() {
        ApiService.getActives()
            .then(result => {
                console.log('Gainers', result);
                let filteredData = [];
                let length = 10;
                if (result.length > 0) {
                    length = result.length < length ? result.length : length;
                    result.sort(this.custom_sort);
                    for (var i = 0; i < length/2; i++) {
                        filteredData.push(result[i]);
                    }
                    result.sort(this.custom_reverse_sort);
                    for (i = 0; i < length/2; i++) {
                        filteredData.push(result[i]);
                    }
                }
                this.setState({ activesList: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRowActives(listValue) {
        if (listValue !== undefined && listValue.ticker !== undefined) {
            let url = '/chart/' + listValue.ticker;
            return (
                <tr style={{ color: listValue.changesPercentage >= 0 ? 'green' : 'red' }} key={listValue.ticker}>
                    <td style={{ color: listValue.changesPercentage >= 0 ? 'green' : 'red' }}><Link to={url}>{listValue.ticker}</Link></td>
                    <td>{parseFloat(listValue.price).toFixed(2)}</td>
                    <td>{parseFloat(listValue.changesPercentage).toFixed(2)}%</td>
                    <td><Link style={{ color: listValue.changesPercentage >= 0 ? 'green' : 'red' }} to={'/stocks/active'}>Most Active</Link></td>
                </tr>
            )
        }
    }

    custom_sort(a, b) {
        if (a.changesPercentage > b.changesPercentage) { return -1; }
        if (a.changesPercentage < b.changesPercentage) { return 1; }
        return 0;
    }

    custom_reverse_sort(a, b) {
        if (a.changesPercentage > b.changesPercentage) { return 1; }
        if (a.changesPercentage < b.changesPercentage) { return -1; }
        return 0;
    }

    render() {
        let tableRow;
        if (this.state.activesList === undefined || this.state.activesList.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td></tr>
        } else {
            tableRow = this.state.activesList.map(this.renderRowActives.bind(this));
        }

        return (
            <Table bordered hover size="xs" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Ticker</th>
                        <th>Last</th>
                        <th>Change</th>
                        <th><Link to={'/stocks/active'}>Most Active</Link></th>
                    </tr>
                </thead>
                <tbody>
                    {tableRow}
                </tbody>
            </Table>
        );
    }
}

export default Actives;
